import DateTimeUtil from '@/util/date-time-util';

export default {
  methods: {
    getExpectedDuration(timePair) {
      return timePair.startingWorkScheduleDay == null || timePair.absenceType != null
        ? '--:--'
        : DateTimeUtil.getFormattedDuration(timePair.expectedMinuteDuration);
    },
  },
};
